export default [
  {
    path: '/agreed',
    name: 'Agreed',
  },
  {
    path: '/home',
    name: 'Home',
  },
  {
    path: '/create_print',
    name: 'CreatePrint',
  },
  {
    path: '/saved_prints',
    name: 'SavedPrints',
  },
  {
    path: '/saved_print',
    name: 'SavedPrint',
  },
  {
    path: '/setting',
    name: 'Setting',
  },
  {
    path: '/cancel',
    name: 'Cancel',
  },
]
